const config = {
    'a': 'b',
    'TEST': 'TESTING123',
    'firebase': {
        'config': {
            'apiKey': 'AIzaSyBS7-u48IAJzePDpwM-nbKNXULw8kD7HL4',
            'authDomain': 'notification-service-418009.firebaseapp.com',
            'projectId': 'notification-service-418009',
            'storageBucket': 'notification-service-418009.appspot.com',
            'messagingSenderId': '413910393309',
            'appId': '1:413910393309:web:18279bf70b4ef30ee9d634',
        },
        'firestoreDbId': 'notification-service-demo',
        'vapidKey': '',
    },
    'notifications': {
        'pollingInterval': 30000,
        'pageSize': 10,
        'maxDaysHistory': 30,
    },
};
module.exports = config;
